import React, { Component } from 'react';

import ListLinetable from '../ListLinetable';

export default class List extends Component {
	constructor(props) {
		super(props);

		this.renderCols = this.renderCols.bind(this);
		this.renderData = this.renderData.bind(this);
	}

	handleClick(column, sort) {
		const { changeSorting } = this.props;

		changeSorting(column, sort);
	}

	renderCols() {
		const { keys } = this.props;

		return keys.map(value => (
			<th
				key={value.id}
			>
				{value.title }
			</th>
		));
	}

	renderData() {
		const {
			elements, keys, funcUpdate, funcEdit,
		} = this.props;

		return elements.map(element => (
			<ListLinetable
				element={element}
				keys={keys}
				funcUpdate={funcUpdate}
				funcEdit={funcEdit}
				key={element.id}
			/>
		));
	}

	render() {
		const { elements } = this.props;

		if (elements.length === 0) {
			return (
				<p>Você ainda não possui relatórios.</p>
			);
		}

		return (
			<div className="table-responsive">
				<table className="table table-hover">
					<thead>
						<tr>
							{this.renderCols()}
						</tr>
					</thead>

					<tbody>
						{this.renderData()}
					</tbody>
				</table>
			</div>
		);
	}
}
